export default "__VITE_ASSET__d6abb291__"